import { Col, Flex, Row, theme, Typography } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCarSide } from '@fortawesome/free-solid-svg-icons';
import { STEPS_CONFIG } from '@/pages/QuotationPage/constants/stepsConfig';
import { FormTheme } from '@/features/externalForm/components/FormTheme';

const { Text, Title } = Typography;

const CARD_SHADOW = '0 1px 2px rgba(16,24,40,.06), 0 16px 48px rgba(16,24,40,.08)';

const BrandPanel = ({ form, currentStep }) => {
  const { token: themeToken } = theme.useToken();
  const panelBg = themeToken.colorPrimaryActive;
  const centered = form.logoPosition === 'center';

  return (
    <Flex
      vertical
      gap={32}
      align={centered ? 'center' : 'flex-start'}
      style={{
        background: panelBg,
        color: '#ffffff',
        padding: '32px 24px',
        minHeight: '100%',
        textAlign: centered ? 'center' : 'left',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {form.logo && (
        <img
          src={form.logo}
          alt='Logo de la agencia'
          style={{
            width: '100%',
            height: 180,
            objectFit: 'contain',
            objectPosition: centered ? 'center' : 'left center',
            display: 'block',
          }}
        />
      )}
      <Flex vertical gap={10} style={{ width: '100%' }}>
        <Title level={3} style={{ color: '#ffffff', margin: 0, fontWeight: 700 }}>{form.title}</Title>
        <Text style={{ color: 'rgba(255,255,255,.92)', fontSize: 16 }}>{form.subtitle}</Text>
      </Flex>
      <Flex vertical gap={18} style={{ marginTop: 'auto', paddingTop: 16, width: '100%', textAlign: 'left' }}>
        <Text style={{ color: 'rgba(255,255,255,.88)', fontSize: 12, fontWeight: 600, letterSpacing: '0.08em' }}>
          RUTA DE COTIZACIÓN
        </Text>
        {STEPS_CONFIG.map(({ title }, step) => {
          const active = step === currentStep;
          return (
            <Flex key={title} gap={12} align='center'>
              <Flex
                align='center'
                justify='center'
                aria-current={active ? 'step' : undefined}
                style={{
                  width: 32,
                  height: 32,
                  borderRadius: '50%',
                  flex: '0 0 32px',
                  background: active ? '#ffffff' : panelBg,
                  border: active ? 'none' : '2px solid rgba(255,255,255,.45)',
                  color: active ? panelBg : 'rgba(255,255,255,.88)',
                  fontWeight: 600,
                }}
              >
                {active ? <FontAwesomeIcon icon={faCarSide} aria-hidden='true' /> : step + 1}
              </Flex>
              <Text style={{ color: active ? '#ffffff' : 'rgba(255,255,255,.88)', fontWeight: active ? 600 : 500 }}>
                {title}
              </Text>
            </Flex>
          );
        })}
      </Flex>
    </Flex>
  );
};

const FormColumns = ({ form, currentStep, children }) => (
  <Row align='stretch'>
    <Col xs={24} lg={8}>
      <BrandPanel form={form} currentStep={currentStep} />
    </Col>
    <Col xs={24} lg={16} style={{ display: 'flex', flexDirection: 'column', background: '#ffffff' }}>
      {children}
    </Col>
  </Row>
);

export const PublicFormShell = ({ form, currentStep = 0, embedded = false, children }) => (
  <FormTheme config={form}>
    {embedded ? (
      <FormColumns form={form} currentStep={currentStep}>{children}</FormColumns>
    ) : (
      <div
        style={{
          width: '100%',
          maxWidth: 1120,
          margin: '0 auto',
          background: '#ffffff',
          borderRadius: 20,
          overflow: 'hidden',
          boxShadow: CARD_SHADOW,
        }}
      >
        <FormColumns form={form} currentStep={currentStep}>{children}</FormColumns>
      </div>
    )}
  </FormTheme>
);
